<template>
	<el-dialog :title="`${title}`" width="800px" :visible.sync="batchAddshow" :close-on-click-modal="false" center>
		<h2>当前题目 : {{ question.questionsName }}</h2>
		<div style="max-width: 1100px; overflow-x: auto;">
			<table>
				<tr>
					<th class="td_width">列标题</th>
					<th class="td_width">验证属性</th>
					<th class="td_width">范围</th>
				</tr>
				<tr v-for="item in question.questionsSonList[0].optionList" :key="item.SonId">
					<td class="td_width">
						<div class="table-th">
							<template>
								<span>{{ item.labelName }}</span>
							</template>
						</div>
					</td>
					<td class="td_width" style="text-align: center">
						<el-select size="small" v-model="item.type" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</td>
					<td class="td_width" style="text-align: center">
						<div v-if="item.type == '3' || item.type == '4'">
							最小值 :
							<el-input-number size="small" style="width: 80px;" v-model="item.minNum" :controls="false"></el-input-number>
							最大值 :
							<el-input-number size="small" style="width: 80px;" v-model="item.maxNum" :controls="false"></el-input-number>
						</div>
						<div v-else-if="item.type == '1' || item.type == '2' || item.type == '24'">
							最小字数 :
							<el-input-number size="small" style="width: 80px;" v-model="item.minNum" :controls="false"></el-input-number>
							最大字数 :
							<el-input-number size="small" style="width: 80px;" v-model="item.maxNum" :controls="false"></el-input-number>
						</div>
						<div v-else-if="item.type == '10'"><el-input size="small" v-model="item.optionName" style="margin-right: 10px;"></el-input></div>
						<div v-else></div>
					</td>
				</tr>
			</table>
		</div>
		<span slot="footer" class="dialog-footer">
			<!-- <el-button @click="cancelAdd">取 消</el-button> -->
			<el-button type="primary" @click="batchAdd" :loading="loading">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { v1 as UUID } from 'uuid';
export default {
	// 批量添加选项、行、列
	name: 'setColumnProperties',
	props: {
		title: {
			type: String,
			default: ''
		},
		functionName: {
			type: String,
			default: ''
		},
		question: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			batchAddshow: false,
			addBatch: '',
			loading: false,
			placeholder: '',
			defaultOptionList: [],
			options: [
				{
					value: '1',
					label: '多行文本'
				},
				{
					value: '2',
					label: '单行文本'
				},
				{
					value: '3',
					label: '整数'
				},
				// {
				// 	value: '4',
				// 	label: '小数'
				// },
				// {
				// 	value: '5',
				// 	label: '日期'
				// },
				{
					value: '6',
					label: '手机'
				},
				{
					value: '7',
					label: '固话'
				},
				// {
				// 	value: '8',
				// 	label: '手机或固话'
				// },
				{
					value: '9',
					label: '邮件'
				},
				{
					value: '10',
					label: '下拉选项'
				},
				// {
				// 	value: '11',
				// 	label: '多级下拉'
				// },
				{
					value: '12',
					label: '文件上传'
				},
				// {
				// 	value: '13',
				// 	label: '国家及地区'
				// },
				// {
				// 	value: '14',
				// 	label: '省份城市'
				// },
				// {
				// 	value: '15',
				// 	label: '省市区'
				// },
				// {
				// 	value: '16',
				// 	label: '高校'
				// },
				// {
				// 	value: '17',
				// 	label: '地图'
				// },
				{
					value: '18',
					label: '网址'
				},
				{
					value: '19',
					label: '身份证号'
				},
				// {
				// 	value: '20',
				// 	label: '学号'
				// },
				// {
				// 	value: '21',
				// 	label: 'QQ'
				// },
				// {
				// 	value: '22',
				// 	label: '汉字'
				// },
				// {
				// 	value: '23',
				// 	label: '中文姓名'
				// },
				{
					value: '24',
					label: '英文'
				}
				// {
				// 	value: '25',
				// 	label: '英文数字'
				// },
			]
		};
	},
	created() {
		console.log('this.qu$for stion', this.question);
	},
	methods: {
		cancelAdd() {
			this.addBatch = '';
			this.batchAddshow = false;
			this.loading = false;
			this.defaultOptionList = [];
			this.placeholder = '';
		},
		batchAdd() {
			this.loading = true;
			// let optionArr = this.addBatch.split('\n').filter(info => info);
			console.log('question', this.question.questionsSonList);
			// this.question.questionsSonList[0].optionList.forEach(item=>{
			// 判断选项是否为下拉 根据输入值渲染下拉列表
			this.question.questionsSonList.forEach((item2, index2) => {
				item2.optionList = this.question.questionsSonList[0].optionList
				item2.optionList.forEach((item3) => {
					if(item3.type=='10'){
						let options = []
						item3.options = []
						options = item3.optionName.split(';')
						options.forEach(optionsEve=>{
							let obj = {
								value : UUID(),
								label : optionsEve
							}
							item3.options.push(obj)
						})
					}
				});
			});
			// })
			console.log('完成', this.question.questionsSonList);
			// this.$emit('addColumnProperties', optionArr);
			// this.delOption();
			this.cancelAdd();
		},
		delOption() {
			if (this.defaultOptionList.length > 0) {
				switch (this.functionName) {
					case 'batchAdd': // 删除选项
						this.question.optionList = this.question.optionList.filter(info => !info.isDefault);
						break;
					case 'batchAddRows': // 删除行
						this.question.questionsSonList = this.question.questionsSonList.filter(info => !info.isDefault);
						console.log(this.question.questionsSonList);
						break;
					case 'batchAddColumns': // 删除列
						this.question.questionsSonList.forEach(son => {
							son.optionList = son.optionList.filter(info => !info.isDefault);
						});
						break;
				}
			}
		}
	}
};
</script>
<style scoped lang="scss">
/deep/ .textval {
	border: 1px solid #ccc !important;
	width: 120px;
	height: 20px;
	margin: 0 auto;
}
table,
table td,
table th {
	border: 1px solid #ccc;
	border-collapse: collapse;
	font-weight: normal;
}
tr {
	height: 30px;
}
.td_width {
	text-align: center;
	padding: 10px 20px;
}
.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
	display: inline-block;
	margin-top: 5px;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.delete,
.item {
	font-size: 22px !important;
	line-height: 40px !important;
	margin-right: 30px !important;
	text-align: right;
	float: right;
	cursor: pointer;
}
.item .el-badge__content.is-fixed {
	top: 10px;
}
.item.drag-handle {
	cursor: move;
}
.el_item_option {
	line-height: 40px;
	height: 44px;
}

.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

/deep/.el-textarea .el-textarea__inner {
	border: 1px solid #dcdfe6 !important;
	background-color: #fff;
}
.table-th {
	display: flex;
	justify-content: center;
}
</style>
